// Filters server-rendered service-card grids by audience.
// Markup contract (see ServiceCardsBlock.cshtml):
//   [data-service-card-filter]      wrapper
//     [data-sc-filter-input]        radio inputs; value = audience node id, "" = All
//     [data-sc-filter-list]         the grid; children .service-card[data-audiences="id id ..."]
//     [data-sc-filter-empty]        message shown when nothing matches (optional)
//     [data-sc-filter-reset]        button inside the empty message that resets to All (optional)

// Re-colour the VISIBLE cards so pink/blue keeps alternating after some are hidden.
// CSS :nth-child counts hidden siblings, so we drive it from JS instead.
function applyAlternation(cards) {
    let visibleIndex = 0;

    cards.forEach((card) => {
        if (card.classList.contains('service-card--hidden')) return;

        const primary = visibleIndex % 2 === 0;
        visibleIndex += 1;

        card.classList.toggle('service-card--colour-primary', primary);
        card.classList.toggle('service-card--colour-secondary', !primary);

        const button = card.querySelector('.service-card__button');
        if (button) {
            button.classList.toggle('button--primary', primary);
            button.classList.toggle('button--secondary', !primary);
        }
    });
}

// Read the chosen audience id from the filter control (a <select>, or radios as a fallback).
function readSelected(root) {
    const select = root.querySelector('select[data-sc-filter-input]');
    if (select) return (select.value || '').trim();

    const checked = root.querySelector('[data-sc-filter-input]:checked');
    return (checked?.value || '').trim();
}

// Float the label up when an audience is chosen, drop it back to placeholder for "All".
function updateFloatedLabel(root, selected) {
    const select = root.querySelector('select[data-sc-filter-input]');
    const field = select && select.closest('.form-field');
    if (field) field.classList.toggle('form-field--floated-label-dirty', selected !== '');
}

function applyFilter(root) {
    const selected = readSelected(root);
    updateFloatedLabel(root, selected);

    const list = root.querySelector('[data-sc-filter-list]');
    if (!list) return;

    const cards = list.querySelectorAll('.service-card');
    let visibleCount = 0;

    cards.forEach((card) => {
        const ids = (card.getAttribute('data-audiences') || '').split(/\s+/).filter(Boolean);
        const matches = !selected || ids.includes(selected);
        card.classList.toggle('service-card--hidden', !matches);
        if (matches) visibleCount += 1;
    });

    applyAlternation(cards);

    const count = root.querySelector('[data-sc-filter-count]');
    if (count) {
        count.hidden = visibleCount === 0;
        count.textContent = `Showing ${visibleCount} ${visibleCount === 1 ? 'service' : 'services'}`;
    }

    const empty = root.querySelector('[data-sc-filter-empty]');
    if (empty) empty.hidden = visibleCount !== 0;
}

function initRoot(root) {
    const inputs = root.querySelectorAll('[data-sc-filter-input]');
    if (!inputs.length) return;

    inputs.forEach((input) => {
        input.addEventListener('change', () => applyFilter(root));
    });

    const reset = root.querySelector('[data-sc-filter-reset]');
    if (reset) {
        reset.addEventListener('click', () => {
            const select = root.querySelector('select[data-sc-filter-input]');
            if (select) {
                select.value = '';
            } else {
                const all = root.querySelector('[data-sc-filter-input][value=""]');
                if (all) all.checked = true;
            }
            applyFilter(root);
        });
    }

    // Apply initial state (handles back/forward cache restoring a non-default radio).
    applyFilter(root);
}

document.querySelectorAll('[data-service-card-filter]').forEach(initRoot);
